import { IconOsOff, IconOsOn, IconRobotOff, IconRobotOn } from '@assets/images/main/icon';
import {
  IntegrationLabel,
  IntegrationLabel1,
  IntegrationLabel2,
  IntegrationLabel3,
  integrationOverviewDesktop11,
  integrationOverviewDesktop12,
  integrationOverviewDesktop13,
  integrationOverviewDesktop14,
  integrationOverviewDesktop15,
  integrationOverviewDesktop21,
  integrationOverviewDesktop22,
  integrationOverviewDesktop23,
  integrationOverviewDesktop24,
  integrationOverviewDesktop31,
  integrationOverviewDesktop32,
  integrationOverviewDesktop33,
  integrationOverviewDesktop34,
  integrationOverviewMobile11,
  integrationOverviewMobile12,
  integrationOverviewMobile13,
  integrationOverviewMobile14,
  integrationOverviewMobile15,
  integrationOverviewMobile21,
  integrationOverviewMobile22,
  integrationOverviewMobile23,
  integrationOverviewMobile24,
  integrationOverviewMobile31,
  integrationOverviewMobile32,
  integrationOverviewMobile33,
  integrationOverviewMobile34,
  integrationOverviewTablet11,
  integrationOverviewTablet12,
  integrationOverviewTablet13,
  integrationOverviewTablet14,
  integrationOverviewTablet15,
  integrationOverviewTablet21,
  integrationOverviewTablet22,
  integrationOverviewTablet23,
  integrationOverviewTablet24,
  integrationOverviewTablet31,
  integrationOverviewTablet32,
  integrationOverviewTablet33,
  integrationOverviewTablet34,
} from '@assets/images/main/integration';
import {
  IntegrationDetailVideoDesktop1,
  IntegrationDetailVideoDesktop2,
  IntegrationDetailVideoDesktop3,
  IntegrationDetailVideoMobile1,
  IntegrationDetailVideoMobile2,
  IntegrationDetailVideoMobile3,
  IntegrationDetailVideoTablet1,
  IntegrationDetailVideoTablet2,
  IntegrationDetailVideoTablet3,
} from '@assets/images/main/video/integration';

export default {
  mainPage: {
    product: {
      title: 'Các gói sản phẩm phù hợp với môi trường sử dụng',
      desc: 'Hãy tham khảo các gói sản phẩm có thể ứng dụng trong môi trường y tế.',
      robotBasic: {
        title: 'Gói cơ bản robot giao hàng',
        desc: 'Sự kết hợp giữa hệ thống định vị trong nhà và hệ thống robot, có thể triển khai nhanh chóng với cấu hình đơn giản',
      },
      delivery: {
        title: 'Gói xếp/dỡ hàng tự động không người lái',
        desc: 'Cấu hình sản phẩm được cấu hình để robot giao hàng có thể xếp/dỡ hàng<br/>hoàn toàn tự động, không cần người vận hành.',
      },
      disinfection: {
        title: 'Gói quản lý rủi ro cao',
        desc: 'Gói cấu hình hỗ trợ quản lý việc giao nhận các vật tư y tế <br/> có nguy cơ lây nhiễm cao một cách an toàn',
      },
    },
  },

  banner: {
    label: IntegrationLabel,
    title: 'Hệ thống tích hợp cho khả năng mở rộng vượt trội hơn.',
    desc: '',

    schemeTitle: 'Hệ thống camera do Orbro đề xuất.',
    schemeDesc: 'Cần hỗ trợ lựa chọn?',
    schemeDesc2: 'Liên hệ ngay, chuyên gia ra vào sẽ tư vấn bạn.',
    phone: '1522-9928',
  },

  bannerData: [
    {
      icon: IconRobotOn,
      iconInv: IconRobotOff,
      image: '',
      iconText: 'Hệ thống robot',
      sub: 'New',
      link: '/vi/integration/robot',
    },
  ],

  video: {
    title: 'Kết hợp giữa công nghệ định vị và robot giao hàng trong nhà',
    desc: [
      {
        text: 'Hệ thống robot tích hợp với công nghệ định vị của ORBRO cho phép theo dõi vị trí robot<br/>theo thời gian thực và giám sát toàn bộ tiến trình hoạt động một cách trực quan.',
      },
    ],
  },

  delivery: {
    label: IntegrationLabel1,
    title: 'Tích hợp hệ thống robot giao hàng',
    desc: 'Cung cấp khả năng theo dõi vị trí và trạng thái hoạt động của robot theo thời gian thực thông qua hệ thống định vị của ORBRO.',

    card: [
      {
        videoTag: true,
        video: {
          desktop: IntegrationDetailVideoDesktop1,
          tablet: IntegrationDetailVideoTablet1,
          mobile: IntegrationDetailVideoMobile1,
        },
        title: 'Khởi đầu cho việc quản lý và theo dõi vị trí robot',
        desc: 'Dựa trên hệ thống định vị của ORBRO, có thể theo dõi vị trí robot theo thời gian thực,<br/>và liên kết với nhiều thiết bị khác nhau để giám sát tình trạng vận hành của robot, hỗ trợ quản lý hiệu quả.',
        img: {
          desktop: integrationOverviewDesktop11,
          tablet: integrationOverviewTablet11,
          mobile: integrationOverviewMobile11,
        },
      },
      {
        title: 'Kết hợp với hệ thống định vị ORBRO',
        desc: 'Thông qua hệ thống tích hợp của ORBRO, việc liên kết giữa robot<br/>và hệ thống định vị có thể thực hiện một cách dễ dàng.',
        img: {
          desktop: integrationOverviewDesktop12,
          tablet: integrationOverviewTablet12,
          mobile: integrationOverviewMobile12,
        },
      },
      {
        title: 'Giám sát trạng thái công việc',
        desc: 'Theo dõi trạng thái hoạt động của robot theo thời gian thực và phản ứng kịp thời khi có tình huống phát sinh.',
        img: {
          desktop: integrationOverviewDesktop13,
          tablet: integrationOverviewTablet13,
          mobile: integrationOverviewMobile13,
        },
      },
      {
        videoTag: true,
        video: {
          desktop: IntegrationDetailVideoDesktop2,
          tablet: IntegrationDetailVideoTablet2,
          mobile: IntegrationDetailVideoMobile2,
        },
        title: 'Giám sát vị trí robot      ',
        desc: 'Cung cấp thông tin vị trí hiện tại của từng robot theo thời gian thực.',
        img: {
          desktop: integrationOverviewDesktop14,
          tablet: integrationOverviewTablet14,
          mobile: integrationOverviewMobile14,
        },
      },
      {
        videoTag: true,
        video: {
          desktop: IntegrationDetailVideoDesktop3,
          tablet: IntegrationDetailVideoTablet3,
          mobile: IntegrationDetailVideoMobile3,
        },
        title: 'Quản lý nhiều robot',
        desc: 'Có thể quản lý đồng thời nhiều robot một cách hiệu quả.',
        img: {
          desktop: integrationOverviewDesktop15,
          tablet: integrationOverviewTablet15,
          mobile: integrationOverviewMobile15,
        },
      },
    ],
  },

  loading: {
    label: IntegrationLabel2,
    title: 'Tích hợp hệ thống xếp dỡ hàng tự động không người lái',
    desc: 'Từ việc xếp hàng lên robot giao hàng đến dỡ hàng, toàn bộ quá trình có thể vận hành tự động,<br/>thông qua việc tích hợp thiết bị xếp hàng, robot cộng tác và tủ lưu trữ vào một hệ thống duy nhất.',

    card: [
      {
        title: 'Tích hợp thiết bị xếp hàng',
        desc: 'Việc tích hợp thiết bị xếp hàng cho phép gọi robot, và hệ thống ORBRO sẽ nhận thông tin về trạng thái đến nơi và sẵn sàng xếp hàng của robot, giúp tự động hóa toàn bộ quá trình vận hành.',
        img: {
          desktop: integrationOverviewDesktop21,
          tablet: integrationOverviewTablet21,
          mobile: integrationOverviewMobile21,
        },
      },
      {
        title: 'Tích hợp robot cộng tác',
        desc: 'Thông qua việc tích hợp robot cộng tác, hệ thống có thể kiểm tra trạng thái<br/>khi robot giao hàng đến nơi và tự động thực hiện quá trình dỡ hàng.',
        img: {
          desktop: integrationOverviewDesktop22,
          tablet: integrationOverviewTablet22,
          mobile: integrationOverviewMobile22,
        },
      },
      {
        title: 'Tích hợp tủ lưu trữ thông minh',
        desc: 'Thông qua bảng điều khiển tùy chỉnh (dashboard), người dùng có thể dễ dàng giám sát dữ liệu quan trọng, nhanh chóng nắm bắt thông tin và đưa ra quyết định hiệu quả dựa trên các hiểu biết thu được.',
        img: {
          desktop: integrationOverviewDesktop23,
          tablet: integrationOverviewTablet23,
          mobile: integrationOverviewMobile23,
        },
      },
      {
        title: 'Theo dõi tình trạng hoạt động theo thời gian thực',
        desc: 'Tình hình kho hàng, trạng thái vận hành theo thời gian thực, v.v.<br/>Trạng thái hoạt động của tất cả các thiết bị được cung cấp trên một màn hình duy nhất.',
        img: {
          desktop: integrationOverviewDesktop24,
          tablet: integrationOverviewTablet24,
          mobile: integrationOverviewMobile24,
        },
      },
    ],
  },

  service: {
    label: IntegrationLabel3,
    title: 'Tích hợp hệ thống khử trùng',
    desc: 'ORBRO OS mạnh mẽ và tiện lợi, nhưng quá trình thiết lập không hề phức tạp.<br/>Mọi thiết bị đều có thể được cài đặt dễ dàng và sử dụng ngay lập tức.',

    card: [
      {
        title: 'Thiết bị khử trùng plasma',
        desc: 'Thiết bị nhanh chóng tăng đến nhiệt độ cần thiết để tiệt trùng rác thải y tế và dụng cụ y tế, giúp rút ngắn thời gian của một chu trình tiệt trùng và đảm bảo tiệt trùng hoàn hảo thông qua việc cung cấp đồng đều chất tiệt trùng đã được hóa hơi.',
        img: {
          desktop: integrationOverviewDesktop31,
          tablet: integrationOverviewTablet31,
          mobile: integrationOverviewMobile31,
        },
      },
      {
        title: 'Thiết bị khử trùng UVC',
        desc: 'Sử dụng khả năng khử khuẩn mạnh mẽ của tia UVC kết hợp với tính an toàn của đèn LED để mang lại hiệu quả khử trùng cao và an toàn.',
        img: {
          desktop: integrationOverviewDesktop32,
          tablet: integrationOverviewTablet32,
          mobile: integrationOverviewMobile32,
        },
      },
      {
        title: 'Tích hợp thiết bị khử trùng HPV',
        desc: 'Robot giao hàng sau khi trở về từ khu vực ô nhiễm sẽ tự động trải qua quá trình<br/>tự khử khuẩn/tiệt trùng không tiếp xúc.',
        img: {
          desktop: integrationOverviewDesktop33,
          tablet: integrationOverviewTablet33,
          mobile: integrationOverviewMobile33,
        },
      },
      {
        title: 'Theo dõi trạng thái vận hành của từng thiết bị',
        desc: 'Cung cấp chức năng giám sát theo thời gian thực không chỉ đối với trạng thái kết nối<br/>và tình trạng thiết bị của các thiết bị khử trùng đã tích hợp, mà còn bao gồm cả<br/>trạng thái hoạt động của từng thiết bị.',
        img: {
          desktop: integrationOverviewDesktop34,
          tablet: integrationOverviewTablet34,
          mobile: integrationOverviewMobile34,
        },
      },
    ],
  },
};
